import React, { useState } from 'react';
import SpinnerOverlay from 'src/components/common/SpinnerOverlay';
import PDAHeader from 'src/components/common/Header';
import usePDA1040_R01Store from './usePDA1040_R01Store';
import { usePDAContainer } from 'src/hooks/usePDAContainer';
import PDA1040_R01Content from './PDA1040_R01Content';
import PDA1040_R01Search from './PDA1040_R01Search';
import PDA1040_R01OrderList from './PDA1040_R01OrderList';
import PDA1040_R01Info from './PDA1040_R01Info';
import PDA1040_R01Table from './PDA1040_R01Table';
import { PDA1040_R01HeaderDto } from 'src/containers/PDA/PDA1040_R01/PDA1040_R01Dto';

interface PDA1040_R01ContainerProps {
  menuNm: string;
  menuCd?: string;
  onBack?: () => void;
}

const PDA1040_R01Container: React.FC<PDA1040_R01ContainerProps> = ({
  menuNm,
  menuCd,
  onBack,
}) => {
  // Store에서 상태 가져오기
  const { loading, reset, orderList, detailList, selectedOrder, checkedList, scannedItem, clearCheckedList } = usePDA1040_R01Store();

  // 화면 전환 상태 (true: 목록, false: 상세)
  const [showList, setShowList] = useState(true);

  // 공통 PDA 컨테이너 로직
  const { handleMenuClick } = usePDAContainer(reset);

  // 비즈니스 로직
  const {
    handleSearchOrders,
    handleSelectOrder,
    handleScanBarcode,
    handleCheckTransport,
    handleCompleteTransport,

  } = PDA1040_R01Content();

  // 발주 선택 시 상세 화면으로 전환
  const onSelectOrder = async (order: PDA1040_R01HeaderDto) => {
    await handleSelectOrder(order);
    setShowList(false);
  };

  // 뒤로가기: 상세 화면에서 목록으로
  const onBackToList = () => {
    // 검수 목록 초기화 (뒤로 가기 시 취소)
    clearCheckedList();
    setShowList(true);
  };

  return (
    <div className="w-full h-screen flex flex-col bg-white fixed inset-0">
      {/* 헤더 */}
      <PDAHeader 
        menuNm={menuNm} 
        menuCd={menuCd} 
        onBack={showList ? onBack : onBackToList} 
        onMenuClick={handleMenuClick} 
      />

      {/* 메인 컨텐츠 */}
      <div className="flex-1 overflow-hidden">
        {showList ? (
          /* 1번 화면: 발주 목록 */
          <div className="h-full flex flex-col overflow-hidden">
            <PDA1040_R01Search onSearch={handleSearchOrders} />
            <PDA1040_R01OrderList orders={orderList} onSelectOrder={onSelectOrder} />
          </div>
        ) : (
          /* 2번 화면: 발주 상세 */
          <div className="h-full flex flex-col overflow-hidden">
            {/* 상단: 입고 등록 폼 */}
            <div className="h-2/4 border-b border-gray-200 overflow-y-auto">
              <PDA1040_R01Info
                onScanBarcode={handleScanBarcode}
                onCheck={handleCheckTransport}
                onComplete={handleCompleteTransport}
                checkedCount={checkedList.length}
              />
            </div>

            {/* 하단: 발주 상세 그리드 */}
            <div className="h-2/4 overflow-y-auto">
              <PDA1040_R01Table
                details={detailList}
                checkedList={checkedList}
                scannedItemCd={scannedItem?.itemCd}
              />
            </div>
          </div>
        )}
      </div>

      {loading && <SpinnerOverlay text="처리 중입니다..." />}
    </div>
  );
};

export default PDA1040_R01Container;
